import { render, staticRenderFns } from "./personal-info.vue?vue&type=template&id=59e3a0b2&scoped=true&"
import script from "./personal-info.vue?vue&type=script&lang=js&"
export * from "./personal-info.vue?vue&type=script&lang=js&"
import style0 from "./personal-info.vue?vue&type=style&index=0&id=59e3a0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e3a0b2",
  null
  
)

export default component.exports